import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { CollectionResponseDto } from '../../../store/landscapeAPI/collection/dto/response/collection-response.dto';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsCollectionsForm,
  TranslationOrganism,
} from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import cn from 'classnames';
import styles from './ReportingDetailsCollectionsEditTemplate.module.css';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

export interface ReportingDetailsCollectionsEditTemplateProps {
  data: CollectionResponseDto;
  handleEditCollection: (goal: CollectionResponseDto) => void;
  handleOnChange: (goal: CollectionResponseDto) => void;
  handleImageOnChange: (ImageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsCollectionsEditTemplate: FC<
  ReportingDetailsCollectionsEditTemplateProps
> = ({
  data,
  handleEditCollection,
  handleOnChange,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Edit Collection" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/collections')}
          className={cn(styles.buttonLink)}
        >
          Go back to collection overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsCollectionsForm
        data={data}
        callbackFn={handleEditCollection}
        handleOnChange={handleOnChange}
        handleImageOnChange={handleImageOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsCollectionsEditTemplate;
